import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

export default function SubscriptionTerms() {
  const { pick } = useLanguage();
  const copy = {
    kicker: { en: "Chesshood subscriptions", pl: "Subskrypcje Chesshood", es: "Suscripciones Chesshood" },
    title: {
      en: "Subscription Terms",
      pl: "Warunki subskrypcji",
      es: "Terminos de suscripcion",
    },
    paragraphs: {
      en: [
        "Chesshood Pro is available as an auto-renewable monthly subscription and an auto-renewable yearly subscription.",
        "Long Game Training is a separate web membership. It includes 7 days of free access without payment details, then costs £0.50 per month if you choose to subscribe after the free period.",
        "Payment is charged at confirmation of purchase through the billing platform you use: Stripe on web, App Store on iPhone/iPad, and Google Play on Android.",
        "Subscriptions renew automatically unless cancelled at least 24 hours before the end of the current billing period.",
        "You can manage or cancel your subscription at any time in your Stripe customer portal, App Store account settings, or Google Play account settings.",
        "Any free trial portion, if offered, is forfeited when a paid subscription begins.",
        "Access to Pro features depends on your subscription remaining active and on the entitlement being synced to your Chesshood account.",
      ],
      pl: [
        "Chesshood Pro jest dostepne jako automatycznie odnawialna subskrypcja miesieczna oraz roczna.",
        "Long Game Training jest osobnym dostepem webowym. Obejmuje 7 dni bezplatnego dostepu bez podawania danych platniczych, a po tym okresie kosztuje £0.50 miesiecznie, jesli zdecydujesz sie wykupic subskrypcje.",
        "Platnosc jest pobierana przy potwierdzeniu zakupu przez wybrana platforme: Stripe na webie, App Store na iPhone i iPadzie oraz Google Play na Androidzie.",
        "Subskrypcje odnawiaja sie automatycznie, chyba ze zostana anulowane co najmniej 24 godziny przed koncem biezacego okresu.",
        "Mozesz zarzadzac subskrypcja lub ja anulowac w dowolnym momencie w panelu Stripe, ustawieniach App Store lub ustawieniach Google Play.",
        "Kazda bezplatna wersja probna, jesli jest oferowana, przepada po rozpoczeciu platnej subskrypcji.",
        "Dostep do funkcji Pro zalezy od aktywnej subskrypcji oraz od synchronizacji uprawnienia z kontem Chesshood.",
      ],
      es: [
        "Chesshood Pro esta disponible como suscripcion mensual auto-renovable y suscripcion anual auto-renovable.",
        "Long Game Training es una membresia web separada. Incluye 7 dias de acceso gratuito sin datos de pago y despues cuesta £0.50 al mes si decides suscribirte al terminar el periodo gratuito.",
        "El pago se cobra al confirmar la compra a traves de la plataforma que utilices: Stripe en web, App Store en iPhone/iPad y Google Play en Android.",
        "Las suscripciones se renuevan automaticamente a menos que se cancelen al menos 24 horas antes del final del periodo actual.",
        "Puedes gestionar o cancelar tu suscripcion en cualquier momento desde tu panel de Stripe, los ajustes de App Store o los ajustes de Google Play.",
        "Cualquier periodo de prueba gratuito, si se ofrece, se pierde al comenzar una suscripcion de pago.",
        "El acceso a las funciones Pro depende de que tu suscripcion siga activa y de que el entitlement este sincronizado con tu cuenta Chesshood.",
      ],
    },
  };

  return (
    <div style={{ maxWidth: 920, margin: "0 auto", color: "#f2e8d3" }}>
      <div
        style={{
          padding: 24,
          borderRadius: 24,
          background: "linear-gradient(180deg, #131313, #090909)",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 24px 50px rgba(0,0,0,0.32)",
        }}
      >
        <div
          style={{
            color: "#f0b454",
            fontSize: 12,
            fontWeight: 900,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}
        >
          {pick(copy.kicker)}
        </div>
        <h1 style={{ marginTop: 10, color: "#fff6de", fontWeight: 900 }}>
          {pick(copy.title)}
        </h1>
        <div style={{ color: "#d8ccb4", lineHeight: 1.7 }}>
          {pick(copy.paragraphs).map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
